import { Injectable } from '@angular/core';
import { ReadyHttpClient } from './ready-http-client';
import { IOrderAheadTimes } from '../models/order-ahead-times.model';
import { OrderMenuApi } from './order-menu.api';

@Injectable({
  providedIn: 'root'
})
export class OrdersApi {
  constructor(
    private http: ReadyHttpClient,
    private orderMenuApi: OrderMenuApi
  ) {}

  getOrderAheadTimes(locationId: string): Promise<IOrderAheadTimes> {
    return this.http.get<IOrderAheadTimes>(
      `/locations/${locationId}/orders/nexttimeslot`
    );
  }

  async submitDelayedPaymentOrder(
    beaconId: string,
    recaptchaToken: string
  ): Promise<{ orderId: string }> {
    return this.http.post(`/tables/${beaconId}/orders/orderAtTable`, {
      ...(await this.orderMenuApi.buildSubmitOrderPayload()),
      recaptchaToken
    });
  }
}
